module.exports = ".gcss {\n    background-color: #4285f4;\n    color: white;\n    text-align: left;\n    padding: 0;\n    width: 190px\n}"